export const FILE_FORMATS = {
  PDF: 'PDF',
  DOCX: 'DOCX',
};

export const FILE_FORMAT_LABELS = {
  [FILE_FORMATS.PDF]: 'PDF',
  [FILE_FORMATS.DOCX]: 'Word',
};
